import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const WAS_LOGGED_IN_KEY = 'rg_was_logged_in';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
          <p className="mt-4 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || user === false) {
    const wasLoggedIn = localStorage.getItem(WAS_LOGGED_IN_KEY);
    if (wasLoggedIn) {
      localStorage.removeItem(WAS_LOGGED_IN_KEY);
      return <Navigate to="/login?session=expired" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};